import { objectKeys } from "app/helpers/objects";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

export const dedupeFilterKeys = (filters: readonly string[]): readonly string[] => [...new Set(filters)];

export const pickChangedKeys = <T extends IPlainObject>(previous: Partial<T>, next: Partial<T>): readonly string[] =>
    objectKeys<Partial<T>>(next).filter((key) => previous[key] !== next[key]) as readonly string[];
